
















































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { Data } from "@/data/data";
import { UnitHelper } from "@/helper/unitHelper";
import { Document } from "@/model/document2/document";
import { Page } from "@/model/document2/page/page";

// ボタン
import AllSurface from "../resources/allSurface.vue";
import OnlyDesign from "../resources/onlyDesign.vue";
import RadioOn from "../resources/radioOn.vue";
import RangeSlider from '../../../../components/VRangeSlider.vue';

@Component({
  components: {
    RangeSlider,
    AllSurface,
    OnlyDesign,
    RadioOn
  }
})
export default class Export extends Vue
{
    //export範囲(0=面全体、1=デザイン部分)
    private exportArea = 0;

    //0=png、1=jpeg
    private exportType = 0;

    //解像度(1から7倍まで)
    private resolution = 1;

    public get currentDocument(): Document {
        return this.$store.getters.document;
    }

    public get currentPage(): Page {
        var document = this.currentDocument;
        return document.pageList[document.currentPageIndex];
    }

    mounted()
    {
        // もし一フレームしかない用紙だったら
        if(this.currentPage.designMaxNumber == 1)
        {
            var design = this.$store.getters.design;
            //もし短辺が210mm以上、長辺が297mm以上だったら
            if(Math.max(design.width, design.height) >= 297 &&
                Math.min(design.width, design.height) >= 210)
            {
                this.resolution = 7
            }
        }
    }

    get resolutionWidth(): number
    {
        return Math.floor(this.$store.getters.design.width * this.getScale());
    }

    get resolutionHeight(): number
    {
        return Math.floor(this.$store.getters.design.height * this.getScale());
    }

    private getScale()
    {
        let pt = UnitHelper.convert(1, "mm", "pt");
        return pt * this.resolution;
    }

    private onExport()
    {
        this.$emit("onOk", { isClipLayer : this.exportArea == 1, quality : this.resolution, fileType : this.getFileType() });
        // 閉じる
        this.$emit("close");
    }

    private getFileType()
    {
        return this.exportType == 1 ? "jpg" : "png";
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigBorderColor(){
        var style = {
            border : "solid 2px " + this.userConfigColor
        };
        return style;
    }
    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }
}
